/** Elapsed maintenance duration: 0:01 … 59:59, then 1ч 0 мин … */
export function formatMaintenanceElapsed(elapsedSec: number): string {
  const total = Math.max(0, Math.floor(elapsedSec));
  if (total < 3600) {
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  return `${hours}ч ${minutes} мин`;
}
